import { Suspense } from 'react';
import { Box, MantineColor, MantineSpacing, ScrollArea } from '@mantine/core';
import { AppBreadcrumbs } from './AppBreadcrumbs';
import { ContentPaneOverlayProvider, ContentPaneOverlaySlot } from './ContentPaneOverlay';
import PageLoader from 'src/UI/loader/PageLoader';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  bg?: MantineColor;
  p?: MantineSpacing;
};

export function AppContentPane({ children, style, bg, p }: Props) {
  return (
    <ContentPaneOverlayProvider>
      <Box
        pos="relative"
        bg={bg ?? 'contentBackground'}
        style={{
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          flex: 1,
          minWidth: 0,
          ...style,
        }}
      >
        <ContentPaneOverlaySlot />
        <ScrollArea
          h="100%"
          w="100%"
          scrollbarSize={6}
          type="scroll"
          styles={{
            root: {
              borderRadius:
                'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
            },
            content: {
              minHeight: '100%',
              height: '100%',
            },
            viewport: {
              overscrollBehavior: 'contain',
            },
            scrollbar: {
              background: 'transparent',
              marginTop: 'var(--mantine-spacing-xxl)',
              marginBottom: 'var(--mantine-spacing-xxxl)',
              marginRight: 2,
              padding: 0,
            },
            thumb: {
              background: 'black',
            },
          }}
        >
          <Box bg={bg ?? 'contentBackground'} px={p ?? 'xxl'} py={p ?? 'lg'} h="100%">
            <AppBreadcrumbs />
            <Suspense fallback={<PageLoader absolute={false} />}>{children}</Suspense>
          </Box>
        </ScrollArea>
      </Box>
    </ContentPaneOverlayProvider>
  );
}
